module.exports = __webpack_public_path__ + "static/media/Black.e5257114.png";